<div class="xp-sidebar__panel"
     [class.xp-sidebar__panel--collapsed]="collapsed()"
     [class.xp-sidebar__panel--dark]="darkMode()"
     [class.xp-sidebar__panel--visible]="visible()">
	<div class="xp-sidebar__top">
		<button *ngIf="!logoSrc()"
		        class="xp-sidebar__toggle"
		        [class.xp-sidebar__toggle--wide]="!collapsed()"
		        (click)="toggleCollapsed()"
		        aria-label="Toggle sidebar"
		        title="Menu">
			<span class="material-icons">menu</span>
		</button>
		<ng-container *ngIf="logoSrc()">
			<img *ngIf="!collapsed()"
			     class="xp-sidebar__logo"
			     [src]="logoSrc()"
			     [alt]="logoAlt()"
			     width="160"
			     height="40"
			     loading="eager" />
			<button class="xp-sidebar__toggle"
			        (click)="toggleCollapsed()"
			        aria-label="Toggle sidebar"
			        title="Toggle sidebar">
				<span class="material-icons">{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</span>
			</button>
		</ng-container>
	</div>

	<nav class="xp-sidebar__nav">
		<ul class="xp-sidebar__list">
			<ng-container *ngTemplateOutlet="itemList; context: { $implicit: items(), level: 0 }"></ng-container>
		</ul>
	</nav>

	<div *ngIf="showFooter()" class="xp-sidebar__footer">
		<div *ngIf="showAppearanceToggle()" class="xp-sidebar__appearance">
			<span *ngIf="!collapsed()" class="xp-sidebar__appearance-label">Appearance</span>
			<div class="xp-sidebar__appearance-row">
				<button type="button"
				        class="xp-sidebar__switch"
				        [class.xp-sidebar__switch--on]="darkMode()"
				        (click)="darkModeChange.emit(!darkMode())"
				        [attr.aria-checked]="darkMode()"
				        role="switch"
				        aria-label="Toggle dark mode">
					<span class="xp-sidebar__knob"></span>
				</button>
			</div>
		</div>
		<div *ngIf="userName() && !collapsed()" class="xp-sidebar__logout xp-sidebar__logout--user">
			<span class="xp-sidebar__user-avatar">{{ userInitial() }}</span>
			<div class="xp-sidebar__user-info">
				<span class="xp-sidebar__user-name">{{ userName() }}</span>
				<span *ngIf="userEmail()" class="xp-sidebar__user-email">{{ userEmail() }}</span>
			</div>
			<button class="xp-sidebar__logout-icon" (click)="logout.emit()" aria-label="Logout" title="Logout">
				<span class="material-icons">logout</span>
			</button>
		</div>
		<button *ngIf="!userName() || collapsed()" class="xp-sidebar__logout" (click)="logout.emit()">
			<span class="material-icons">logout</span>
			<span *ngIf="!collapsed()">Logout</span>
		</button>
	</div>
</div>

<ng-template #linkContent let-item>
	<span *ngIf="item.icon" class="material-icons">{{ item.icon }}</span>
	<span *ngIf="!collapsed()" class="xp-sidebar__label">{{ item.label }}</span>
	<span *ngIf="!collapsed() && item.badge !== undefined"
	      class="xp-sidebar__badge"
	      [attr.aria-label]="item.badgeLabel">
		{{ item.badge }}
	</span>
	<span *ngIf="!collapsed() && hasChildren(item)"
	      class="xp-sidebar__chevron"
	      [class.xp-sidebar__chevron--open]="isOpen(item)">
		<span class="material-icons xp-sidebar__chevron-icon">expand_more</span>
	</span>
</ng-template>

<ng-template #itemList let-items let-level="level">
	<li *ngFor="let item of items" class="xp-sidebar__item">
		<a *ngIf="hasChildren(item); else leafLink"
		   href="#"
		   [ngClass]="linkClasses(item, level)"
		   [style.--xp-sidebar-level]="level"
		   [attr.data-testid]="item.testId"
		   (click)="$event.preventDefault(); toggleGroup(item)">
			<ng-container *ngTemplateOutlet="linkContent; context: { $implicit: item }"></ng-container>
		</a>
		<ng-template #leafLink>
			<a [routerLink]="leafCommands(item)"
			   [ngClass]="linkClasses(item, level)"
			   [style.--xp-sidebar-level]="level"
			   [attr.data-testid]="item.testId"
			   (click)="leafSelected.emit()">
				<ng-container *ngTemplateOutlet="linkContent; context: { $implicit: item }"></ng-container>
			</a>
		</ng-template>

		<div *ngIf="collapsed()"
		     class="xp-sidebar__caption"
		     [class.xp-sidebar__caption--active]="isActive(item)">
			{{ item.label }}
		</div>

		<ul *ngIf="hasChildren(item) && isOpen(item)" class="xp-sidebar__sub-list">
			<ng-container *ngTemplateOutlet="itemList; context: { $implicit: item.children, level: level + 1 }"></ng-container>
		</ul>
	</li>
</ng-template>
